import * as React from 'react';
import IAgreement, { TAgreementState } from './IAgreement';
import DocumentPreview from '@appComponents/DocumentPreview/DocumentPreview';
import SecondaryMarketService from '@services/SecondaryMarket.service';

import * as style from './AgreementStyle.module.scss'
import * as elemsStyle from '@appStyles/_elements.module.scss';

class Agreement extends React.Component<IAgreement, TAgreementState> {
  state = {
    riskWarningsDocs: this.props.riskWarnings,
    documentPreview: false,
    documentHtml: undefined,
    checkedAll: this.props.checks.length === this.props.agreements!.length,
  };

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const checkedAll = this.state.checkedAll && this.state.riskWarningsDocs &&
    this.state.riskWarningsDocs.filter(elem => elem.id === Number(name)).length ?
      false : this.state.checkedAll;

    this.setState({
      checkedAll,
    });

    if (this.props.checks.includes(name)) {
      this.props.updateState({
        checks: this.props.checks.filter(elem => elem !== name),
      });
    } else {
      this.props.updateState({
        checks: [...this.props.checks, name],
      });
    }
  }

  toggleDocPreview = () => {
    if (this.state.documentHtml) {
      this.setState({
        documentPreview: true,
      });
      return;
    }

    let response;

    if (this.props.documentData.orderData) {
      response = SecondaryMarketService.getSellerAgreements(this.props.documentData);
    } else {
      response = SecondaryMarketService.getBuyerAgreements(this.props.documentData);
    }

    response.then((resp) => {
      this.setState({
        documentHtml: resp.data.html,
        documentPreview: true,
      });
    }).catch((err) => {
      this.setState({
        documentHtml: err.response,
        documentPreview: true,
      });
    });
  }

  onChangeCheckedAll = () => {
    this.setState({
      checkedAll: !this.state.checkedAll,
    });
    if (this.state.riskWarningsDocs) {
      const riskIds = this.state.riskWarningsDocs.map(elem => elem.id.toString());
      const generalChecks = this.props.checks.filter(elem => !riskIds.includes(elem));
      if (!this.state.checkedAll) {
        this.props.updateState({
          checks: this.state.riskWarningsDocs
            .map(elem => String(elem.id))
            .concat(generalChecks),
        });
      } else {
        this.props.updateState({
          checks: generalChecks,
        });
      }
    }
  }

  closePreview = () => {
    this.setState({
      documentPreview: false,
    });
  }

  render() {
    return (
      <div>
        {this.props.agreements && this.props.agreements.map((elem, index) => {
          return (
            <div
              key={elem.id}
              className={style.agreement}
            >
              <div className={[elemsStyle.customCheckbox, style.checkbox].join(' ')}>
                <input
                  checked={this.props.checks.includes(elem.id.toString())}
                  type="checkbox"
                  onChange={this.onChange}
                  id={`agreement${elem.id}`}
                  name={`${elem.id}`}
                />
                <label
                  htmlFor={`agreement${elem.id}`}
                  className={style.title}
                  data-cy={`agreement-${index}`}
                >
                  {elem.title}
                </label>
              </div>
              {elem.text && (
                <div className={style.text}>
                  <p>
                    {elem.text}
                  </p>
                </div>
              )}
              {elem.document && (
                <React.Fragment>
                  <div className={style.searchIcon}>
                    <svg>
                      <use
                        href={'#icon-search'}
                        xlinkHref={'#icon-search'}
                      />
                    </svg>
                    <button
                      className={style.documentPreviewBtn}
                      onClick={this.toggleDocPreview}
                    >
                      Agreement Preview
                    </button>
                  </div>
                  <DocumentPreview
                    documentName={elem.document.title}
                    isVisible={this.state.documentPreview}
                    html={this.state.documentHtml}
                    closePreview={this.closePreview}
                  />
                </React.Fragment>
              )}
            </div>
          );
        })}
        <div>
          <h2 className={style.sectionText}>Risk Warnings</h2>
          <hr/>
          <div className={[elemsStyle.customCheckbox, style.checkbox].join(' ')}>
            <input
              checked={this.state.checkedAll}
              type="checkbox"
              onChange={this.onChangeCheckedAll}
              id="checkedall"
            />
            <label
              htmlFor="checkedall"
              className={style.title}
              data-cy="agree-to-all-below"
            >
              Agree to all below
            </label>
          </div>
          {this.state.riskWarningsDocs && this.state.riskWarningsDocs.map((elem) => {
            return (
              <div
                key={elem.id}
                className={style.agreement}
              >
                <div className={[elemsStyle.customCheckbox, style.checkbox].join(' ')}>
                  <input
                    checked={this.props.checks.includes(elem.id.toString())}
                    type="checkbox"
                    onChange={this.onChange}
                    id={`agreement${elem.id}`}
                    name={`${elem.id}`}
                  />
                  <label
                    htmlFor={`agreement${elem.id}`}
                    className={style.title}
                  >
                    {elem.title}
                  </label>
                </div>
                {elem.text && (
                  <div className={style.text}>
                    <p>
                      {elem.text}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Agreement;
